module.exports = __webpack_public_path__ + "img/nav_9.97255a21.png";